import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '@env/environment';
import { SharedModule } from '@shared/shared.module';

const baseUrl = `${environment.apiBaseUrl}platform/addon-categories`;

@Injectable({
  providedIn: SharedModule
})
export class CategoryService {

  constructor(private http: HttpClient) { }

  list(): Observable<Addon.Category[]> {
    return this.http.get<Addon.Category[]>(`${baseUrl}`);
  }
}
